// extracted by mini-css-extract-plugin
export default {"container":"GYzXGt","thumbnail-wrapper":"rQhkce","thumbnailWrapper":"rQhkce","prev-button":"mUnnYK","prevButton":"mUnnYK","next-button":"jSMkMZ","nextButton":"jSMkMZ"};